<template>
  <p class="field-error"><slot /></p>
</template>

<script>
export default {}
</script>

<style lang="scss">
.field-error {
  margin: 5px 0 0;
  color: #ff0022;
  font-family: $ToyotaBook;
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
}

@include media-min($desktop-width) {
  .field-error {
    font-size: 16px;
    font-weight: 400;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseErrorMessage.vue